import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Switch,
  Route,
  Redirect,
  Link,
} from 'react-router-dom';
import { Query } from 'react-apollo';
import BackIcon from '../../images/back-icon.svg';
import Loading from '../Loading';
import BlankState from '../BlankState';
import DetailNav from './DetailNav';
import Profile from './Profile';
import Contacts from './Contacts';
import ProgramStatus from './ProgramStatus';
import Applications from './Applications';
import DetailFormWrapper from './DetailFormWrapper';
import {
  adminSchoolSchoolMarketQuery,
  adminEditSchoolProfileMutation,
  adminEditSchoolContactsMutation,
  adminUpdateApplicationsMutation,
  adminUpdateProgramStatusMutation,
} from '../../apollo';

const detailRoutes = [{
  path: '/school-market/schools/:id',
  mutation: adminEditSchoolProfileMutation,
  component: Profile,
}, {
  path: '/school-market/schools/:id/contacts',
  mutation: adminEditSchoolContactsMutation,
  component: Contacts,
}, {
  path: '/school-market/schools/:id/program-status',
  mutation: adminUpdateProgramStatusMutation,
  component: ProgramStatus,
}, {
  path: '/school-market/schools/:id/applications',
  mutation: adminUpdateApplicationsMutation,
  component: Applications,
}];

const SchoolDetailSchoolMarket = ({ match, ...otherProps }) => (
  <Fragment>
    <Query
      query={adminSchoolSchoolMarketQuery}
      variables={{
        schoolId: match.params.id,
      }}
      fetchPolicy="cache-and-network"
    >
      {({ loading, error, data }) => {
        const loadingData = !data.adminSchoolSchoolMarket && loading;
        if (loadingData || error) {
          return (
            <Fragment>
              <div className="profile-intro">
                <Link
                  to="/school-market/schools"
                  className="back-btn w-inline-block"
                >
                  <img className="image-14" src={BackIcon} alt="back" />
                  <div className="text-block-11">back to schools</div>
                </Link>
              </div>
              {loading && <Loading />}
              {error && <BlankState title="Error" subtitle="There was an error loading" />}
            </Fragment>
          );
        }

        const { adminSchoolSchoolMarket: school } = data;
        return school ? (
          <Fragment>
            <div className="profile-intro">
              <Link
                to="/school-market/schools"
                className="back-btn w-inline-block"
              >
                <img className="image-14" src={BackIcon} alt="back" />
                <div className="text-block-11">back to schools</div>
              </Link>
              <h2 className="purple-headline">{school.name}</h2>
              <div className="divider-2 settings" />
            </div>
            <div className="div-block-13">
              <DetailNav {...otherProps} match={match} />
              <Switch>
                {
                    detailRoutes.map(({ path, mutation, component: Component }) => (
                      <Route
                        key={path}
                        exact
                        path={path}
                        render={() => (
                          <DetailFormWrapper
                            Form={Component}
                            mutation={mutation}
                            school={school}
                            {...otherProps}
                          />
                        )}
                      />
                    ))
                  }
                <Route component={() => <Redirect to="/school-market/schools" />} />
              </Switch>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="profile-intro">
              <Link
                to="/school-market/schools"
                className="back-btn w-inline-block"
              >
                <img className="image-14" src={BackIcon} alt="back" />
                <div className="text-block-11">back to schools</div>
              </Link>
            </div>
            <BlankState title="Error" subtitle="There was an error loading" />
          </Fragment>
        );
      }}
    </Query>
  </Fragment>
);

SchoolDetailSchoolMarket.propTypes = {
  match: PropTypes.object.isRequired,
};

export default SchoolDetailSchoolMarket;
